import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=2923e479&"
import script from "./FlagIcon.vue?vue&type=script&lang=ts&"
export * from "./FlagIcon.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./FlagIcon.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports